export default __webpack_public_path__ + "static/media/331.147a371d.jpg";